module.exports = __webpack_public_path__ + "static/media/img.2db84080.png";